<template>
  <div id="questionBankDetails">
    <div class="questionBankDetails">
      <div class="details_a" v-if="infor">
        <!--题干-->
        <div class="_con" v-if="infor.titlelang&&(infor.titlelang.mn||infor.titlelang.zh)">
          <div style="font-size: 20px" v-if="infor.titlelang.mn" class="content_con titlefont aqt_lang_mn"
               v-html="U2M(infor.titlelang.mn)"></div>
          <div style="font-size: 20px" v-if="infor.titlelang.zh" class="content_con titlefont aqt_su"
               v-html="U2M(infor.titlelang.zh)"></div>
        </div>
        <!--答案-->
        <div class="_con tt" v-if="textmn||textzh">
          <div @click="setImgBigger" style="font-size: 18px" v-if="infor.checkedtitlelang.mn"
               class="kk content_con titlefont aqt_lang_mn"
               v-html="U2M(textmn)"></div>
          <div style="font-size: 18px" v-if="infor.checkedtitlelang.zh" class="yy content_con titlefont aqt_su"
               v-html="textzh"></div>
        </div>
        <!--        来源-->
        <div class="_con" v-if="infor.fromnamelang&&(infor.fromnamelang.mn||infor.fromnamelang.zh)">
          <div class="title_con">
            <p class="titlefont aqt_lang_mn">{{ $t('m.source')|U2M }}</p>
          </div>
          <div style="font-size: 18px" v-if="infor.fromnamelang.mn" class="content_con titlefont aqt_lang_mn"
               v-html="U2M(infor.fromnamelang.mn)"></div>
          <div style="font-size: 18px" v-if="infor.fromnamelang.zh" class="content_con titlefont aqt_su"
               v-html="U2M(infor.fromnamelang.zh)"></div>
        </div>
      </div>
      <!--    加载动画-->
      <AqtSpin v-if="isSpin"></AqtSpin>
<!--      <goback style="position:fixed!important;top: 30px!important;right: 100px!important;"></goback>-->
    </div>
    <!--图片放大屈戌-->
    <div
        class="imgDolg"
        v-show="imgPreview.show"
        @click.stop="imgPreview.show = false"
    >
      <i
          class="el-icon-close"
          id="imgDolgClose"
          @click.stop="imgPreview.show = false"
      ></i>
      <img @click.stop="imgPreview.show = true" :src="imgPreview.img"/>
    </div>


  </div>
</template>

<script>
export default {
  props: {
    infoId: {
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {
      isSpin: false,
      infor: '',

      imgPreview: {
        img: "",
        show: false
      },

      textmn:'',
      textzh:'',
    }
  },
  methods: {
    setImgBigger(e) {
      let that = this
      if (e.target.nodeName === 'IMG') {
        that.imgPreview.img = e.target.currentSrc
        that.imgPreview.show = true
      }
    },
    //  获取知识库的详情
    gettQuetionDetails() {
      const _this = this
      this.isSpin = true
      let cond = {
        stem_id:_this.infoId
      }
      _this.$httpsencrypt.post(`api/web/v3/stem/findstem`,cond)
          .then(val => {
            if (val.code == 200) {
              _this.infor = val.data
              if(val.data.checkedtitlelang){
                _this.infor.checkedtitlelang=_this.$webcrypto.get(val.data.checkedtitlelang)
                //修改富文本编辑器里图片的大小
                if (_this.infor.checkedtitlelang && (_this.infor.checkedtitlelang.mn || _this.infor.checkedtitlelang.zh)) {
                  if (_this.infor.checkedtitlelang.mn) {
                    _this.textmn = _this.infor.checkedtitlelang.mn.replace(/\<img/gi, '<img style="height:100%;width:auto;"');
                  }
                  if (_this.infor.checkedtitlelang.zh) {
                    _this.textzh = _this.infor.checkedtitlelang.zh.replace(/\<img/gi, '<img style="height:100%;width:auto;"');
                  }
                }
              }


              setTimeout(function () {
                _this.$nextTick(() => {
                  const boxindex = document.querySelectorAll('.tt');
                  const dbox = document.querySelectorAll('.kk');
                  const dbox_two = document.querySelectorAll('.yy');

                  if (dbox[0] && dbox_two[0]) {
                    boxindex[0].style.minWidth = dbox[0].clientWidth + dbox_two[0].clientWidth + 'px'
                  } else {
                    if (dbox[0]) {
                      boxindex[0].style.minWidth = dbox[0].clientWidth + 'px'
                    }
                    if (dbox_two[0]) {
                      boxindex[0].style.minWidth = dbox_two[0].clientWidth + 'px'
                    }
                  }
                })
              }, 800)

              this.isSpin = false
            } else {
              _this.infor = ''
            }
          }).catch(e => {
        this.isSpin = false
        _this.infor = ''
      })

    }
  },
  created() {
    this.gettQuetionDetails()
    let info={
      book_id: this.infoId,
      type: 20,
      path: this.$route.path,
      mark: '知识数据库',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
#questionBankDetails {
  width: 100%;
  height: 100%;
  display: flex;

  .questionBankDetails {
    width: 100%;
    height: 100%;
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;

    .details_a {
      background: #ffffff;
      height: 100%;
      //min-width: 50px;
      display: flex;
      margin-right: 10px;
      padding-left: 10px;

      .title_content {
        width: 50px;
        height: 100%;
        padding: 25px 0;
        font-size: 18px;
        color: #888888;
        line-height: 50px;
      }

      ._con {
        min-width: 50px;
        height: 100%;
        padding: 15px 0;
        display: flex;
        //padding-left: 20px;

        .title_con {
          width: 32px;
          height: 100%;

          img {
            width: 100%;
            height: auto;
          }

          p {
            width: 100%;
            font-size: 20px;
            //font-size: 20px;
            color: var(--themeColor);
            margin: 8px auto;
          }
        }

        .content_con {
          height: 100%;
          padding: 27px 20px 20px 10px;
          font-size: 20px;
          color: #888888 !important;
          line-height: 24px;
        }
      }

      ._con_one {
        min-width: 50px;
        height: 100%;
        display: flex;

        .content_con {
          height: 100%;
          padding: 27px 20px 27px 10px;
          font-size: 18px;
          color: #888888;
          line-height: 24px;
          text-indent: 30px;
        }
      }
    }
  }

  //富文本图片放大
  .imgDolg {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 9999;
    background-color: rgba(140, 134, 134, 0.6);
    top: 0;
    left: 0;
    //display: flex;
    //align-items: center;
    //justify-content: center;
    overflow: auto;

    #imgDolgClose {
      position: fixed;
      top: 35px;
      cursor: pointer;
      right: 7%;
      font-size: 50px;
      color: white;
    }

    img {
      //height: 98%;
      width: 50%;
      margin: 0 auto;
      display: block;
    }
  }


}
</style>
